<template>
    <div class="templateSayhi  template-btn" :style="{ 'padding-top': getTemplatePaddingTop }">

        <Head></Head>
        <div class="animation" v-if="animationLoading && templateData">
            <TemplateSayhiTwo :templateData="templateData" v-if="getDisplayTemplate" />
            <TemplateSayhiOne :templateData="templateData" v-else />
        </div>
        <div class="btn-warp">
            <div @click="contimueClick()" class="button active text_1"
                v-html="templateData.languageConfig[$language].buttonText">
            </div>

        </div>
    </div>
</template>
</template>
<script>
import webConfig from "@/config/web.config/index";
import Head from "./components/head.vue"
import { sendStatsigEvent } from "@/utils/statsig";
import { setmMxpanelUserInfo } from "@/utils/mixpanel";
import mixinTemplate from "@/mixin";
import TemplateSayhiOne from "./components/templateSayhi/templateSayhiOne.vue";
import TemplateSayhiTwo from "./components/templateSayhi/templateSayhiTwo.vue";
export default {
    name: "templateSayhi",
    mixins: [mixinTemplate],
    components: {
        Head,
        TemplateSayhiOne,
        TemplateSayhiTwo
    },
    computed: {
        getDisplayTemplate() {
            return this.$store.state.onBoardingRecordInfo[webConfig.statsigConfig.paywallParamName] ==
                webConfig.statsigConfig.selectPaywallParam
        }
    },
    data() {
        return {
            webConfig: webConfig
        }
    },
    mounted() {
        sendStatsigEvent('PlanReadyScreen', this.$store.state.onBoardingRecordInfo[this.webConfig.statsigConfig.paywallParamName]);
        setmMxpanelUserInfo({
            'Experiment Name': webConfig.statsigConfig.paywallExperimentName,
            Parameters: [this.$store.state.onBoardingRecordInfo[webConfig.statsigConfig.paywallParamName]]
        })
        let uid = this.$store.state.onBoardingRecordInfo[this.$utils.getKey('uid')];
        //保底避免未存入uid的情况
        uid = uid ? uid : window.sessionStorage.getItem('uid')
        this.$store.commit("updateOnBoardingRecord", {
            key: this.$utils.getKey('uid'),
            value: uid,
        });

    }

}
</script>